import React, { useState, useEffect, useRef } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    Button,
    Typography,
    FormHelperText,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGlobalContext } from "../../context/Context";
import AddIcon from "@mui/icons-material/Add";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const Addstaff = ({ openDialog, setOpenDialog, edit, setEdit, selectedEmployee, setEmployees }) => {
    const { loading, setLoading } = useGlobalContext();
    const [designation, setDesignation] = useState();
    const [newDesignation, setNewDesignation] = useState("");
    const [showAddField, setShowAddField] = useState(false);
    const [ID_Proof, setID_Proof] = useState();
    const [Address_Proof, setAddress_Proof] = useState();
    const [Photo, setPhoto] = useState();
    const [Resume, setResume] = useState();
    const addFieldRef = useRef(null);


    // Conditional dialog title and description
    const title = edit ? "Edit staff" : "Add Staff";
    const description = edit
        ? "Update Staff details."
        : "Add a new Staff to the list.";

    //handle close
    const handleClose = () => {
        setOpenDialog(false);
        setEdit(false);

        if (edit && selectedEmployee) {
            // Set form data for edit
            setFormData({
                Name: selectedEmployee?.Name || "",
                Designation: selectedEmployee?.Designation?._id || "",
            });
        } else {
            // Reset form data and errors
            setFormData({
                Name: "",
                Designation: "",
                Phone: "",
                Alt_Phone: "",
                Address: "",
                Skills: "",
                Salary: "",
                YrsofExp: "",
                DateofJoin: "",
            });
            setErrors({
                Name: "",
                Designation: "",
                Phone: "",
                Alt_Phone: "",
                Address: "",
                Skills: "",
                Salary: "",
                YrsofExp: "",
                DateofJoin: "",
                ID_Proof: "",
                Address_Proof: "",
                Photo: "",
                Resume: ""
            });
        }
    };

    const [errors, setErrors] = useState({
        Name: "",
        Designation: "",
        Phone: "",
        Alt_Phone: "",
        Address: "",
        Skills: "",
        Salary: "",
        YrsofExp: "",
        DateofJoin: "",
        ID_Proof: "",
        Address_Proof: "",
        Photo: "",
        Resume: ""
    });

    //formvalidation
    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        // Name validation
        if (formData.Name.trim() === "") {
            newErrors.Name = "Please enter a name";
            isValid = false;
        }

        // Address validation
        if (formData.Designation.trim() === "") {
            newErrors.Designation = "Designation is required";
            isValid = false;
        }
        // if (formData.Phone.trim() === "") {
        //     newErrors.Phone = "Phone Number is required";
        //     isValid = false;
        // }
        if (formData.Phone.trim() === "") {
            newErrors.Phone = "Phone number is required";
            isValid = false;
        } else if (!/^\d{10}$/.test(formData.Phone.trim())) {
            newErrors.Phone = "Phone number must be 10 digits";
            isValid = false;
        }
        // if (formData.Alt_Phone.trim() === "") {
        //     newErrors.Alt_Phone = "Alternative Phone Number is required";
        //     isValid = false;
        // }
        if (formData.Alt_Phone.trim() !== "" && !/^\d{10}$/.test(formData.Alt_Phone.trim())) {
            newErrors.Alt_Phone = "Alternate Phone number must be 10 digits";
            isValid = false;
        }
        if (formData.Address.trim() === "") {
            newErrors.Address = "Address is required";
            isValid = false;
        }
        if (formData.Skills.trim() === "") {
            newErrors.Skills = "Skills is required";
            isValid = false;
        }
        if (!formData.Specialities) {
            newErrors.Specialities = "Specialities is required";
            isValid = false;
        }
        if (formData.Salary.trim() === "") {
            newErrors.Salary = "Salary is required";
            isValid = false;
        }
        if (formData.YrsofExp.trim() === "") {
            newErrors.YrsofExp = "Years of Experience is required";
            isValid = false;
        }
        if (formData.DateofJoin.trim() === "") {
            newErrors.DateofJoin = "Date Of joining is required";
            isValid = false;
        }
        if (!ID_Proof) {
            newErrors.ID_Proof = "ID Proof is required";
            isValid = false;
        }
        if (!Address_Proof) {
            newErrors.Address_Proof = "Address Proof is required";
            isValid = false;
        }
        if (!Photo) {
            newErrors.Photo = "Photo is required";
            isValid = false;
        }
        if (!Resume) {
            newErrors.Resume = "Resume is required";
            isValid = false;
        }

        // Update the errors state
        setErrors(newErrors);

        return isValid;
    };


    const [formData, setFormData] = useState({
        Name: "",
        Designation: "",
        Phone: "",
        Alt_Phone: "",
        Address: "",
        Skills: "",
        Salary: "",
        YrsofExp: "",
        DateofJoin: "",
    });


    useEffect(() => {

        if (edit && selectedEmployee) {
            setFormData({
                Name: selectedEmployee?.allData?.Name || "",
                Designation: selectedEmployee?.allData?.Designation?._id || "",
                Phone: selectedEmployee?.allData?.Phone || "",
                Alt_Phone: selectedEmployee?.allData?.Alt_Phone || "",
                Address: selectedEmployee?.allData?.Address || "",
                Skills: selectedEmployee?.allData?.Skills || "",
                Specialities: selectedEmployee?.allData?.Specialities || "",
                Salary: selectedEmployee?.allData?.Salary || "",
                YrsofExp: selectedEmployee?.allData?.YrsofExp || "",
                DateofJoin: selectedEmployee?.allData?.DateofJoin || "",
            });
            setID_Proof(selectedEmployee?.allData?.ID_Proof || "");
            setAddress_Proof(selectedEmployee?.allData?.Address_Proof || "");
            setPhoto(selectedEmployee?.allData?.Photo || "");
            setResume(selectedEmployee?.allData?.Resume || "");

        } else {
            setFormData({
                Name: "",
                Designation: "",
                Phone: "",
                Alt_Phone: "",
                Address: "",
                Skills: "",
                Salary: "",
                YrsofExp: "",
                DateofJoin: "",
            });
            setErrors({
                Name: "",
                Designation: "",
                Phone: "",
                Alt_Phone: "",
                Address: "",
                Skills: "",
                Salary: "",
                YrsofExp: "",
                DateofJoin: "",
                ID_Proof: "",
                Address_Proof: "",
                Photo: "",
                Resume: ""
            });
            setErrors({});
            setID_Proof(null);
            setAddress_Proof(null);
            setPhoto(null);
            setResume(null);

        }
    }, [edit && selectedEmployee]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };


    const handleSubmitEmployee = async () => {
        if (!validateForm()) return;

        setLoading(true);

        try {
            const newformData = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                newformData.append(key, value);
            });

            newformData.append('ID_Proof', ID_Proof);
            newformData.append('Address_Proof', Address_Proof);
            newformData.append('Photo', Photo);
            newformData.append('Resume', Resume);

            const url = edit
                ? `/Staff/updateStaff/${selectedEmployee.staffId}`
                : `/Staff/AddStaff`;

            const method = edit ? instance.patch : instance.post;

            const response = await method(url, newformData);

            if (response.data.success === true) {
                toast.success(response.data.message);
                handleClose();
                setEmployees(true);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.log(error);
        } finally {
            setLoading(false);
        }
    };



    const handlegetDesignation = async () => {
        try {
            const response = await instance.get('/Staff/getDesignation');
            setDesignation(response.data.designation);
        } catch (error) {
            console.log(error);
        }
    }
    useEffect(() => {
        handlegetDesignation();
    }, []);

    const handleAddDesignation = async () => {
        if (newDesignation.trim() === "") return;
        try {
            const response = await instance.post('/Staff/AddDesignation', { title: newDesignation });

            if (response.data.status === true) {
                toast.success(response.data.message);
                handlegetDesignation();
                setShowAddField(false);
                setNewDesignation("");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
            console.log(error);
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleAddDesignation();
        }
    };
    // Close input when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (addFieldRef.current && !addFieldRef.current.contains(event.target)) {
                setShowAddField(false);
                setNewDesignation("");
            }
        }

        if (showAddField) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showAddField]);

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {title}
                    <Typography>{description}</Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <hr style={{ margin: "10px 0px" }} />
                <DialogContent dividers>
                    <section className="add-employee">
                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Name"
                                        label="Name"
                                        type="text"
                                        fullWidth
                                        required
                                        name="Name"
                                        value={formData.Name}
                                        onChange={handleInputChange}
                                        error={!!errors.Name}
                                    />
                                    <FormHelperText error={!!errors.Name}>
                                        {errors.Name}
                                    </FormHelperText>
                                </div>
                            </Grid>

                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Phone Number"
                                        label="Phone Number"
                                        type="text"
                                        fullWidth
                                        required
                                        name="Phone"
                                        value={formData.Phone}
                                        onChange={handleInputChange}
                                        error={!!errors.Phone}
                                        inputProps={{ pattern: "[0-9]*", inputMode: "numeric" }}
                                        onKeyDown={(e) => {
                                            if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace") {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                    <FormHelperText error={!!errors.Phone}>
                                        {errors.Phone}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Alternate Phone Number"
                                        label="Alternate Phone Number"
                                        type="text"
                                        fullWidth
                                        // required
                                        name="Alt_Phone"
                                        value={formData.Alt_Phone}
                                        onChange={handleInputChange}
                                        input={{ maxLength: 10, pattern: "[0-9]*", inputMode: "numeric" }}
                                        onKeyDown={(e) => {
                                            if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace") {
                                                e.preventDefault();
                                            }
                                        }}
                                    error={!!errors.Alt_Phone}
                                    />
                                    <FormHelperText error={!!errors.Alt_Phone}>
                                        {errors.Alt_Phone} 
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Address"
                                        label="Address"
                                        type="text"
                                        fullWidth
                                        required
                                        name="Address"
                                        value={formData.Address}
                                        onChange={handleInputChange}
                                        error={!!errors.Address}
                                    />
                                    <FormHelperText error={!!errors.Address}>
                                        {errors.Address}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Skills"
                                        label="Skills"
                                        type="text"
                                        fullWidth
                                        required
                                        name="Skills"
                                        value={formData.Skills}
                                        onChange={handleInputChange}
                                        error={!!errors.Skills}
                                    />
                                    <FormHelperText error={!!errors.Skills}>
                                        {errors.Skills}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Specialities"
                                        label="Specialities"
                                        type="text"
                                        fullWidth
                                        required
                                        name="Specialities"
                                        value={formData.Specialities}
                                        onChange={handleInputChange}
                                        error={!!errors.Specialities}
                                    />
                                    <FormHelperText error={!!errors.Specialities}>
                                        {errors.Specialities}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Salary"
                                        label="Salary"
                                        type="text"
                                        fullWidth
                                        required
                                        name="Salary"
                                        value={formData.Salary}
                                        onChange={handleInputChange}
                                        inputProps={{ pattern: "[0-9]*", inputMode: "numeric" }}
                                        onKeyDown={(e) => {
                                            if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace") {
                                                e.preventDefault();
                                            }
                                        }}
                                        error={!!errors.Salary}
                                    />
                                    <FormHelperText error={!!errors.Salary}>
                                        {errors.Salary}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Yrs of Exp"
                                        label="Yrs of Exp"
                                        type="text"
                                        fullWidth
                                        required
                                        name="YrsofExp"
                                        value={formData.YrsofExp}
                                        onChange={handleInputChange}
                                        inputProps={{ pattern: "[0-9]*", inputMode: "numeric" }}
                                        onKeyDown={(e) => {
                                            if (!/^[0-9]$/.test(e.key) && e.key !== "Backspace") {
                                                e.preventDefault();
                                            }
                                        }}
                                        error={errors.YrsofExp}
                                    />
                                    <FormHelperText error={!!errors.YrsofExp}>
                                        {errors.YrsofExp}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        label="Date of Join"
                                        type="date"
                                        fullWidth
                                        name="DateofJoin"
                                        value={formData.DateofJoin}
                                        onChange={handleInputChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                        error={errors.DateofJoin}
                                    />
                                    <FormHelperText error={!!errors.DateofJoin}>
                                        {errors.DateofJoin}
                                    </FormHelperText>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label" required error={!!errors.Designation}>Select Designation</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            name="Designation"
                                            required
                                            label="Select Designation"
                                            value={formData.Designation}
                                            onChange={handleInputChange}
                                            MenuProps={{ disableAutoFocusItem: true }}
                                            error={errors.Designation}
                                        >
                                            {designation?.map((title) => (
                                                <MenuItem key={title._id} value={title._id}>
                                                    {title.Designation}
                                                </MenuItem>
                                            ))}

                                            {/* Add new designation option inside dropdown */}
                                            <MenuItem disableRipple onClick={(e) => e.stopPropagation()}>
                                                <div ref={addFieldRef} style={{ display: "flex", alignItems: "center", width: "100%" }}>
                                                    {showAddField ? (
                                                        <TextField
                                                            autoFocus
                                                            placeholder="Enter new designation"
                                                            value={newDesignation}
                                                            onChange={(e) => setNewDesignation(e.target.value)}
                                                            onKeyPress={handleKeyPress}
                                                            size="small"
                                                            style={{ flex: 1, marginRight: 8 }}
                                                            onMouseDown={(e) => e.stopPropagation()}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    ) : (
                                                        <IconButton
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setShowAddField(true);
                                                            }}
                                                            size="small"
                                                        >
                                                            <AddIcon /> Add
                                                        </IconButton>
                                                    )}
                                                </div>
                                            </MenuItem>
                                        </Select>
                                        <FormHelperText error={!!errors.Designation}>{errors.Designation}</FormHelperText>
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 8 }}></Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <InputLabel shrink htmlFor="id-proof-upload">Upload ID Proof *</InputLabel>
                                    <TextField
                                        fullWidth
                                        type="file"
                                        accept="image/*, application/pdf"
                                        name="ID_Proof"
                                        onChange={(e) => { setID_Proof(e.target.files[0]); setErrors((prev) => ({ ...prev, ID_Proof: "" })) }}
                                        inputProps={{
                                            "aria-label": "Upload ID Proof",
                                        }}
                                        error={!!errors.ID_Proof}
                                        required
                                    />
                                    <FormHelperText error={!!errors.ID_Proof}>{errors.ID_Proof}</FormHelperText>
                                    {/* <Typography variant="caption" sx={{ color: "gray", mt: 1 }}>
                                        Supported formats: JPEG, PNG, PDF
                                    </Typography> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <InputLabel shrink htmlFor="id-proof-upload">Upload Address Proof *</InputLabel>
                                    <TextField
                                        fullWidth
                                        type="file"
                                        accept="image/*, application/pdf"
                                        name="Address_Proof"
                                        onChange={(e) => { setAddress_Proof(e.target.files[0]); setErrors((prev) => ({ ...prev, Address_Proof: "" })) }}
                                        inputProps={{
                                            "aria-label": "Upload Address Proof",
                                        }}
                                        error={!!errors.Address_Proof}
                                        required
                                    />
                                    <FormHelperText error={!!errors.Address_Proof}>{errors.Address_Proof}</FormHelperText>
                                    {/* <Typography variant="caption" sx={{ color: "gray", mt: 1 }}>
                                        Supported formats: JPEG, PNG, PDF
                                    </Typography> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <InputLabel shrink htmlFor="id-proof-upload">Upload Photo *</InputLabel>
                                    <TextField
                                        fullWidth
                                        type="file"
                                        accept="image/*, application/pdf"
                                        name="Photo"
                                        onChange={(e) => { setPhoto(e.target.files[0]); setErrors((prev) => ({ ...prev, Photo: "" })) }}
                                        inputProps={{
                                            "aria-label": "Upload Photo",
                                        }}
                                        required
                                        error={!!errors.Photo}
                                    />
                                    <FormHelperText error={!!errors.Photo}>{errors.Photo}</FormHelperText>
                                    {/* <Typography variant="caption" sx={{ color: "gray", mt: 1 }}>
                                        Supported formats: JPEG, PNG, PDF
                                    </Typography> */}
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 4 }}>
                                <div className="admin-textfiled">
                                    <InputLabel shrink htmlFor="id-proof-upload">Upload Resume *</InputLabel>
                                    <TextField
                                        fullWidth
                                        type="file"
                                        accept="image/*, application/pdf"
                                        name="Resume"
                                        onChange={(e) => { setResume(e.target.files[0]); setErrors((prev) => ({ ...prev, Resume: "" })) }}
                                        inputProps={{
                                            "aria-label": "Upload Resume",
                                        }}
                                        error={!!errors.Resume}
                                        required
                                    />
                                    <FormHelperText error={!!errors.Resume}>{errors.Resume}</FormHelperText>
                                    {/* <Typography variant="caption" sx={{ color: "gray", mt: 1 }}>
                                        Supported formats: JPEG, PNG, PDF
                                    </Typography> */}
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmitEmployee}
                        className="add-btn"
                    >
                        {loading ? (
                            <CircularProgress size={20} sx={{ color: 'white' }} />
                        ) : (
                            edit ? 'Update' : 'Add'
                        )}
                    </Button>


                </DialogActions>
            </BootstrapDialog>
        </React.Fragment >
    );
};

export default Addstaff;
